// Source
import * as Instance from "./Instance";
import * as ModelHelperSrc from "../model/HelperSrc";
import * as ModelUser from "../model/User";

export const updateDataMyProfile = (
    id: string,
    username: string,
    password: string,
    confirmPassword: string,
    firstName: string,
    lastName: string,
    email: string,
    callback: ModelHelperSrc.IapiCallback
): void => {
    const data = {
        id,
        username,
        password,
        confirm_password: confirmPassword,
        first_name: firstName,
        last_name: lastName,
        email
    };

    Instance.api
        .post<ModelHelperSrc.Iresponse>(
            `/user/update_data/my_profile`,
            {
                headers: {
                    "Content-Type": "application/json"
                }
            },
            data
        )
        .then((response) => {
            return callback(response.data);
        })
        .catch((error: Error) => {
            return callback(error);
        });
};

export const updateDataUserListProfile = (
    id: string,
    username: string,
    password: string,
    confirmPassword: string,
    firstName: string,
    lastName: string,
    email: string,
    isActive: boolean,
    isCheckboxSuperuser: boolean,
    isCheckboxManager: boolean,
    isCheckboxStaff: boolean,
    isCheckboxSupport: boolean,
    callback: ModelHelperSrc.IapiCallback
): void => {
    const data = {
        id,
        username,
        password,
        confirm_password: confirmPassword,
        first_name: firstName,
        last_name: lastName,
        email,
        is_active: isActive,
        is_checkbox_superuser: isCheckboxSuperuser,
        is_checkbox_manager: isCheckboxManager,
        is_checkbox_staff: isCheckboxStaff,
        is_checkbox_support: isCheckboxSupport
    };

    Instance.api
        .post<ModelHelperSrc.Iresponse>(
            `/user/update_data/user_list_profile`,
            {
                headers: {
                    "Content-Type": "application/json"
                }
            },
            data
        )
        .then((response) => {
            return callback(response.data);
        })
        .catch((error: Error) => {
            return callback(error);
        });
};

export const dataList = (dataMain: ModelUser.Idata, sortOrder: string, page: string, callback: ModelHelperSrc.IapiCallback): void => {
    const data = {
        sort_order: sortOrder,
        page: page,
        username: dataMain.username,
        email: dataMain.email,
        latest_update: dataMain.latest_update,
        latest_update_by_id: dataMain.latest_update_by_id as unknown as string,
        is_active: dataMain.is_active.toString()
    } as Record<string, string>;

    const urlParameter = new URLSearchParams(data);

    Instance.api
        .get<ModelHelperSrc.Iresponse>(`/user/data_list?${urlParameter.toString()}`, {
            headers: {
                "Content-Type": "application/json"
            }
        })
        .then((response) => {
            return callback(response.data);
        })
        .catch((error: Error) => {
            return callback(error);
        });
};

export const createData = (
    username: string,
    password: string,
    confirmPassword: string,
    firstName: string,
    lastName: string,
    email: string,
    isActive: boolean,
    isCheckboxSuperuser: boolean,
    isCheckboxManager: boolean,
    isCheckboxStaff: boolean,
    isCheckboxSupport: boolean,
    callback: ModelHelperSrc.IapiCallback
): void => {
    const data = {
        username,
        password,
        confirm_password: confirmPassword,
        first_name: firstName,
        last_name: lastName,
        email,
        is_active: isActive,
        is_checkbox_superuser: isCheckboxSuperuser,
        is_checkbox_manager: isCheckboxManager,
        is_checkbox_staff: isCheckboxStaff,
        is_checkbox_support: isCheckboxSupport
    };

    Instance.api
        .post<ModelHelperSrc.Iresponse>(
            `/user/create_data`,
            {
                headers: {
                    "Content-Type": "application/json"
                }
            },
            data
        )
        .then((response) => {
            return callback(response.data);
        })
        .catch((error: Error) => {
            return callback(error);
        });
};

export const removeData = (id: number, callback: ModelHelperSrc.IapiCallback): void => {
    const data = { id };

    Instance.api
        .post<ModelHelperSrc.Iresponse>(
            "/user/remove_data",
            {
                headers: {
                    "Content-Type": "application/json"
                }
            },
            data
        )
        .then((response) => {
            return callback(response.data);
        })
        .catch((error: Error) => {
            return callback(error);
        });
};

export const optAd = (id: number, callback: ModelHelperSrc.IapiCallback): void => {
    const data = { id };

    Instance.api
        .post<ModelHelperSrc.Iresponse>(
            "/user/opt_api",
            {
                headers: {
                    "Content-Type": "application/json"
                }
            },
            data
        )
        .then((response) => {
            return callback(response.data);
        })
        .catch((error: Error) => {
            return callback(error);
        });
};

export const validationForm = (callback: ModelHelperSrc.IapiCallback): void => {
    Instance.api
        .get<ModelHelperSrc.Iresponse>("/user/validation_form", {
            headers: {
                "Content-Type": "application/json"
            }
        })
        .then((response) => {
            return callback(response.data);
        })
        .catch((error: Error) => {
            return callback(error);
        });
};

export const selectOption = (callback: ModelHelperSrc.IapiCallback): void => {
    Instance.api
        .get<ModelHelperSrc.Iresponse>("/user/select_option", {
            headers: {
                "Content-Type": "application/json"
            }
        })
        .then((response) => {
            return callback(response.data);
        })
        .catch((error: Error) => {
            return callback(error);
        });
};

export const myProfile = (callback: ModelHelperSrc.IapiCallback): void => {
    Instance.api
        .get<ModelHelperSrc.Iresponse>("/user/my_profile", {
            headers: {
                "Content-Type": "application/json"
            }
        })
        .then((response) => {
            return callback(response.data);
        })
        .catch((error: Error) => {
            return callback(error);
        });
};
